import InputField from "../../ui/InputField/InputField";
import classes from "./BasicInfo.module.css";

const carMakes = [
  "Audi",
  "Chevrolet",
  "Cadillac",
  "Acura",
  "BMW",
  "Chrysler",
  "Ford",
  "Buick",
  "INFINITI",
  "GMC",
  "Honda",
  "Hyundai",
  "Jeep",
  "Genesis",
  "Dodge",
  "Jaguar",
  "Kia",
  "Land Rover",
  "Lexus",
  "Mercedes-Benz",
  "Mitsubishi",
  "Lincoln",
  "MAZDA",
  "Nissan",
  "MINI",
  "Porsche",
  "Ram",
  "Subaru",
  "Toyota",
  "Volkswagen",
  "Volvo",
  "Alfa Romeo",
  "FIAT",
  "Freightliner",
  "Maserati",
  "Tesla",
  "Aston Martin",
  "Bentley",
  "Ferrari",
  "Lamborghini",
  "Lotus",
  "McLaren",
  "Rolls-Royce",
  "smart",
  "Scion",
  "SRT",
  "Suzuki",
  "Fisker",
  "Maybach",
  "Mercury",
  "Saab",
  "HUMMER",
  "Pontiac",
  "Saturn",
  "Isuzu",
  "Panoz",
  "Oldsmobile",
  "Daewoo",
  "Plymouth",
  "Eagle",
  "Geo",
  "Daihatsu",
];
const BasicInfo = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  console.log("🚀 BasicInfo Form Data:", formData);

  return (
    <div className={classes.form}>
      <h4>Basic Information</h4>
      <div className={classes.group}>
        <InputField
          labelText="Make"
          name="make"
          value={formData.make}
          options={carMakes}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Model"
          placeholder="Eg. Camry, Civic"
          name="model"
          value={formData.model}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Year"
          name="year"
          placeholder="Eg. 2025"
          value={formData.year}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Color"
          name="color"
          placeholder="Eg. White"
          value={formData.color}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="License Plate"
          name="licensePlate"
          placeholder="Eg. ALM 0000"
          value={formData.licensePlate}
          required
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
